import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';
import { BusinessAbout } from './business-about';
import { BusinessLogoImage } from './business-logo-image';
import { CTAButtons } from './cta-buttons';
import { LocationLabels } from './labels';
import { useLocationCardProps } from './location-card-settings-context';

export const BusinessInfo = ({ withLogo }: { withLogo?: boolean }) => {
  const settings = useLocationCardProps();
  const {
    alignment,
    businessLogo,
    businessName,
    businessAbout,
    ctaButtons,
    locationLabels
  } = settings;

  const hasBusinessInfo = !!businessLogo || !!businessName || !!businessAbout;
  const hasLogo = withLogo && !!settings.businessLogo;
  const hasLabels = locationLabels?.length > 0;

  const regularBlocks = [
    {
      render: <BusinessLogoImage />,
      condition: hasLogo,
      offset: hasLabels ? 20 : 8
    },
    {
      render: <LocationLabels labels={locationLabels} alignment={alignment} />,
      condition: hasLabels,
      offset: 4
    },
    {
      render: (
        <Typography
          textStyle={{ ...settings.businessNameStyle, lineHeight: 1.25 }}
          color={settings.textColor}
        >
          {settings.businessName}
        </Typography>
      ),
      condition: !!settings.businessName,
      offset: hasLabels ? 4 : 8
    },
    {
      render: <BusinessAbout />,
      condition: !!settings.businessAbout,
      offset: hasLabels ? 20 : 8
    },
    {
      render: <CTAButtons />,
      condition: hasBusinessInfo && ctaButtons.length,
      offset: 32
    }
  ].filter(({ condition }) => !!condition);

  return (
    <Container>
      {regularBlocks.map(({ render, offset }, index) => (
        <Block _offset={offset} key={index}>
          {render}
        </Block>
      ))}
    </Container>
  );
};

const Container = styled.div`
  flex-basis: 380px;
  flex-shrink: 0;
  flex-grow: 5;
`;

const Block = styled.div<{ _offset: number }>`
  line-height: 0;

  &:not(:first-child) {
    margin-top: ${({ _offset }) => _offset}px;
  }

  &:last-child {
    margin-bottom: 32px;
  }
`;
